import { render } from "./Reservation_Guide.vue?vue&type=template&id=66fab074"
import script from "./Reservation_Guide.vue?vue&type=script&lang=js"
export * from "./Reservation_Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__